import {
  Text,
  PageTitle,
  Box,
  Flex,
  Grid,
  Link,
  Button,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  GreyWhite,
  Primary14SemiBold,
  Primary13Regular,
  RadioButtonGroup
} from '@sequencehq/core-components'
import { QuoteTemplateEditorKebabMenu } from './QuoteTemplateEditorKebabMenu'
import { useQuoteTemplateEditorHeader } from './useQuoteTemplateEditorHeader'
import { ViewMode } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/useQuoteEditorHeader'

const styles = {
  title: {
    ...Primary14SemiBold,
    color: GreyGrey80
  },
  archivedTitle: {
    ...Primary14SemiBold,
    color: GreyGrey60
  }
}

const viewModeOptions = [
  { value: ViewMode.Edit, label: 'Edit' },
  { value: ViewMode.Preview, label: 'Preview' }
]

export const QuoteTemplateEditorHeader = () => {
  const headerHook = useQuoteTemplateEditorHeader()

  return (
    <>
      <PageTitle title={[headerHook.title, 'Quote templates']} />
      <Grid
        data-testid="quoteTemplate.editor.header"
        gridTemplateColumns="1fr auto 1fr"
        gridTemplateAreas={'"status title options"'}
        width="100%"
        height="48px"
        alignItems="center"
        borderBottom={`1px solid ${GreyGrey30}`}
        backgroundColor={GreyWhite}
        padding="0 16px"
        position="relative"
      >
        <Box gridArea="status">
          <RadioButtonGroup
            options={viewModeOptions}
            value={headerHook.viewMode.current}
            onChange={headerHook.viewMode.onChange}
            data-testid="quoteTemplate.editor.viewMode"
          />
        </Box>
        <Flex gridArea="title" gap="4px" alignItems="center">
          <Text {...Primary13Regular} color={GreyGrey60}>
            <Text as={Link.Unstyled} color="inherit" to="/quotes">
              Quote Templates
            </Text>{' '}
            /{' '}
            <Text
              as="span"
              style={
                headerHook.isArchived ? styles.archivedTitle : styles.title
              }
            >
              {headerHook.title}
            </Text>
          </Text>
        </Flex>

        <Flex gap="8px" gridArea="options" justifyContent="flex-end">
          {headerHook.save.visible && (
            <Button
              variant="primary"
              data-testid="quoteTemplate.editor.header.save"
              onClick={headerHook.save.onClick}
              disabled={headerHook.save.disabled}
            >
              Save template
            </Button>
          )}

          <QuoteTemplateEditorKebabMenu />
        </Flex>
      </Grid>
    </>
  )
}
